import React, { useEffect } from 'react';
import { Box } from '@material-ui/core';
import Header from './headers/Header';
import Content from './content/Content';
import BackButton from './navigationMenu/backButton';
import { useLocation } from 'react-router-dom';
import { MENU_ROUTE } from '../../../constants/Routes';
import LogoutButton from './LogoutButton';
import FlashMessage from '../../common/FlashMessage';
import Footer from '../Footer';
import RipleyBankBannerSticky from '../../business/banners/bank/RipleyBankBannerSticky';
import { MOBILE } from '../../../constants/Devices';

const MobileLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Box display="flex" flexDirection="column" maxWidth="100%">
      <Header />
      <FlashMessage mobile />
      {location.pathname !== MENU_ROUTE && (
        <BackButton pathname={location.pathname} />
      )}
      <RipleyBankBannerSticky
        banner={{
          setAppearanceFor: MOBILE,
        }}
      />
      <Content />

      {location.pathname !== MENU_ROUTE && (
        <React.Fragment>
          <BackButton pathname={location.pathname} middle />
          <LogoutButton />
        </React.Fragment>
      )}
      <Footer onHeight={() => {}} />
    </Box>
  );
};

export default MobileLayout;
